// @flow

import update from "immutability-helper";
import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    charts: {
        languages: null,
        visits: null,
        pages: null,
        usages: null,
    },
    statistics: [],
    pagination: {
        page: 0,
        limit: 20,
        total: 0
    },
    filters: {
        languages: [],
        url: '',
        ip_address: ''
    },
    loading: true
};

type State = { type?: string };

const Statistics = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'STATISTICS_LOADED':
            return {...state, loading: false, statistics: action.payload.statistics, pagination: action.payload.pagination};

        case 'STATISTICS_LANGUAGES_LOAD':
            return update(state, {charts: {languages: {$set: null}}});

        case 'STATISTICS_LANGUAGES_LOADED':
            return update(state, {charts: {languages: {$set: action.payload}}});

        case 'STATISTICS_VISITS_LOAD':
            return update(state, {charts: {visits: {$set: null}}});

        case 'STATISTICS_VISITS_LOADED':
            return update(state, {charts: {visits: {$set: action.payload}}});

        case 'STATISTICS_PAGES_LOAD':
            return update(state, {charts: {pages: {$set: null}}});

        case 'STATISTICS_PAGES_LOADED':
            return update(state, {charts: {pages: {$set: action.payload}}});

        case 'STATISTICS_USAGES_LOAD':
            return update(state, {charts: {usages: {$set: null}}});

        case 'STATISTICS_USAGES_LOADED':
            return update(state, {charts: {usages: {$set: action.payload}}});

        case 'STATISTICS_CHANGE_INPUT':
            const result = /(.*)\.(.*)?/.exec(action.payload.name);
            if (result) {
                const new_state = update(state, {
                    [result[1]]: {
                        [result[2]]: {
                            $set: action.payload.value
                        }
                    }
                });
                return {...new_state};
            }
            return update(state, {filters: {[action.payload.name]: {$set: action.payload.value}}});

        default:
            return {...state};
    }
};

export default Statistics;
